module.exports = __webpack_public_path__ + "img/247x75.52fe2084.png";